import { IMessage } from 'react-stomp-hooks';

import { WEvent } from '../events/WEvent';

export const deserializeWebsocketEvent = (message: IMessage): WEvent =>
  JSON.parse(message.body) as WEvent;
